import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemProps,
  ListItemText,
  Theme,
  styled,
} from "@mui/material";
import { ReactNode } from "react";

import { IconUser03 } from "@dfp/react-icons";

type Props = {
  avatarSize?: keyof Theme["avatarSize"];
  primary: ReactNode;
  secondary?: ReactNode;
} & ListItemProps;

export function ListItemPerson({
  avatarSize = 40,
  primary,
  secondary,
  ...rest
}: Props) {
  return (
    <ListItem {...rest}>
      <StyledListItemAvatar>
        <Avatar
          sx={(theme) => ({
            color: theme.palette.text.main,
            background: theme.palette.custom.fillSecondary,
            fontSize: avatarSize / 2,
            border: "none",
            ...theme.avatarSize[avatarSize],
          })}
        >
          <IconUser03 />
        </Avatar>
      </StyledListItemAvatar>

      <StyledListItemText
        primary={primary}
        secondary={secondary}
        secondaryTypographyProps={{ component: "div" }}
      />
    </ListItem>
  );
}

const StyledListItemText = styled(ListItemText)({
  "& span": {
    fontWeight: 500,
  },
});

const StyledListItemAvatar = styled(ListItemAvatar)(({ theme }) => ({
  minWidth: 0,
  marginRight: theme.spacing(2),
}));
